module.exports = __webpack_public_path__ + "img/question-template.320ec84e.png";